import { AlertPromptBase } from './alert-prompt-base';

export class AlertPromptLogout extends AlertPromptBase<string> {
  override titleTC? = 'AUTH.LOGOUT_ALERT_TITLE';
  override subtitleTC? = 'AUTH.LOGOUT_ALERT_SUBTITLE';
  override cancelTextTC? = 'AUTH.LOGOUT_ALERT_CANCEL_BUTTON';
  override continueTextTC? = 'AUTH.LOGOUT_ALERT_CONTINUE_BUTTON';
}
